// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"SuggestSearch-highlighted--3GwsJ"};